import React from "react";
import { AddCard, Done, DoneAll, EngineeringTwoTone, Event, Notifications, NotificationsOff, PermDataSetting, QuestionMark, ViewKanban } from "@mui/icons-material";
import { Badge, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from "@mui/material";
import Service from "../../../../../util/Service";
import { useProfile } from "../../../../common/useProfile";
import NotificationsDialog from "./NotificationsDialog";
import NotificationCard from "./NotificationCard";
import { useNavigate } from "react-router-dom";

export default function NotificationComp({ style }) {
    const prof = useProfile();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openDialogItem, setOpenDialogItem] = React.useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [notificacoes, setNotificacoes] = React.useState();
    // const [sse, setSse] = React.useState();
    const [current, setCurrent] = React.useState();
    const navigate = useNavigate();
    const [notif, setNotif] = React.useState(true);


    const open = Boolean(anchorEl);
    React.useEffect(() => {
        if (prof.isOk) {
            const s = Service.SSE(
                "/api/security/not/escutaNotificacao/" + prof.profile.login,
                prof.profile.login,
                handleEvent
            );
            return () => {
                s.close();
            };
        }
    }, [prof.isOk]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleEvent = (e) => {
        if (e.success === false) {
            console.error(e.msg);
            setNotif(false);
            return;
        }
        const json = JSON.parse(e);
        setNotificacoes(json);
    }
    const handleClickPopover = (event) => {
        handleClose();
        setOpenDialogItem(true);
    };
    function handleItemClick(e, row) {
        handleClickPopover(e);
        setCurrent(row);
    }
    const SvgImage = ({ svgString }) => {
        const svgDataUri = `data:image/svg+xml;utf8,${encodeURIComponent(svgString)}`;
        return <img width="24px" height="24px" src={svgDataUri} alt="Dynamic SVG" />;
    };
    const handleCloseDialogItem=()=>{
        setOpenDialogItem(false);
    }
    function handleCieneTodas() {
        setOpenDialog(true);
    }
    function handleok() {
        // const dado = prof.profile.id
        // const ok = enviaDadoWS({ dado, type: TYPES.update });
        handleClose();
    }
    function getQtd(){
        let qtd =0;
        if( notificacoes){
            for(const n of notificacoes){
                qtd += n.ids.length;
            }
        }
        return qtd;
    }
    function handleOpenNotificaForm(){
        navigate("/notifManager");
        handleClose();
    }

    if( !prof.isOk) return

    function ShowItem({ row }) {
        let msg = row.titulo;
        let qtd = row.ids.length;
        let menu = <QuestionMark fontSize="small" />;
        if (row.type === 'kanban') menu = <ViewKanban fontSize="small" />
        else if (row.type === 'kanbanCard') menu = <AddCard fontSize="small" />
        else if (row.type === 'solicitacao') menu = <EngineeringTwoTone fontSize="small" />
        else if (row.type === 'event') menu = <Event fontSize="small" />
        else if (row.type === 'DONE') menu = <Done fontSize="small" />
        else if (row.icone) menu = <SvgImage svgString={row.icone} />;
        if (qtd > 1) {
            return (
                <MenuItem onClick={(e) => handleItemClick(e, row)}>
                    <Badge badgeContent={qtd} color="secondary">
                    <ListItemIcon>
                        {menu}
                    </ListItemIcon>
                    <ListItemText>{msg}</ListItemText>
                    </Badge>
                </MenuItem>
            )
        }
        return (
            <MenuItem onClick={(e) => handleItemClick(e, row)}>
                <ListItemIcon>
                    {menu}
                </ListItemIcon>
                <ListItemText>{msg}</ListItemText>
            </MenuItem>
        )
    }

    return (
        <React.Fragment>
            <Tooltip title='Notificações'>
                <IconButton
                    size="small"
                    aria-label="mostra novas notificações"
                    color="inherit"
                    onClick={handleClick}
                    //sx={style != null ? style : {}}
                >
                    <Badge badgeContent={getQtd()} color="error">
                        { notif ? <Notifications />: <NotificationsOff /> }
                    </Badge>
                </IconButton>
            </Tooltip>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                {notificacoes && notificacoes.map((row, id) =>
                    <ShowItem row={row} key={id} />
                )}
                {notificacoes && notificacoes.length > 0 && <Divider />}
                {notificacoes && notificacoes.length > 0 &&
                    <MenuItem onClick={handleCieneTodas}>
                        <ListItemIcon >
                            <DoneAll fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Ciente todas</ListItemText>
                    </MenuItem>}
                {prof.temAcesso("NotifManager") && 
                <MenuItem onClick={handleOpenNotificaForm}>
                    <ListItemIcon >
                        <PermDataSetting fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Configuração</ListItemText>
                </MenuItem> }
            </Menu>
            <NotificationsDialog open={openDialog} setOpen={setOpenDialog} notificacoes={notificacoes} action={handleok} />
            <Dialog
                open={openDialogItem}
                onClose={handleCloseDialogItem}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                role="alertdialog"               
            >
                {/* TÍTULO */}
                <DialogTitle
                    id="alert-dialog-title"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        fontWeight: '700',
                        color: 'var(--pd-primary-dark, #1565c0)',
                        padding: '20px 24px 16px'
                    }}
                >
                    <Notifications color="primary" />
                    Notificações Clínicas
                </DialogTitle>

                {/* CONTEÚDO: Adicionado DialogContent para dar o espaçamento interno perfeito */}
                <DialogContent style={{ padding: '8px 24px', overflowY: 'auto', maxHeight: '60vh' }}>
                    <NotificationCard card={current} close={handleCloseDialogItem}/>
                </DialogContent>

                <Divider />

                {/* BOTÕES DE AÇÃO */}
                <DialogActions style={{ padding: '16px 24px', gap: '8px' }}>
                    <Button
                        onClick={handleCloseDialogItem}
                        variant="outlined"
                        color="inherit"
                        style={{ borderRadius: '8px', textTransform: 'none', fontWeight: '600' }}
                    >
                        Sair
                    </Button>
                    <Button
                        onClick={handleCloseDialogItem}
                        variant="contained"
                        color="primary"
                        style={{ borderRadius: '8px', textTransform: 'none', fontWeight: '600', boxShadow: 'none' }}
                    >
                        Marcar como lida
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}